module.exports = __webpack_public_path__ + "static/media/bird-budgie3.7a119e96.aac";